import { WhiteboardTool } from '@/types/whiteboard';
import { Tool } from './Tool/Tool';
import { brushTool } from './Tool/BrushTool';
import { eraserTool } from './Tool/EraserTool';
import { laserTool } from './Tool/LaserTool';
import { selectTool } from './Tool/SelectTool';
import { shapeTool, ShapeTool } from './Tool/ShapeTool';
import { textTool } from './Tool/TextTool';

export const mapWhiteboard2Toolbar = (tool: WhiteboardTool): Tool | undefined => {
  switch (tool) {
    case WhiteboardTool.PEN:
      return brushTool;
    case WhiteboardTool.ELEMENT_ERASER:
      return eraserTool;
    case WhiteboardTool.LASER:
      return laserTool;
    case WhiteboardTool.SELECT:
      return selectTool;
    case WhiteboardTool.RECT:
    case WhiteboardTool.RECT_FILL:
    case WhiteboardTool.ELLIPSE:
    case WhiteboardTool.ELLIPSE_FILL:
    case WhiteboardTool.LINE:
    case WhiteboardTool.LINE_ARROW:
      return shapeTool;
    case WhiteboardTool.TEXT:
      return textTool;
    default:
      return undefined;
  }
};

export const mapToolbar2Whiteboard = (tool: Tool): WhiteboardTool => {
  if (tool === brushTool) {
    return WhiteboardTool.PEN;
  }
  if (tool === eraserTool) {
    return WhiteboardTool.ELEMENT_ERASER;
  }
  if (tool === laserTool) {
    return WhiteboardTool.LASER;
  }
  if (tool === selectTool) {
    return WhiteboardTool.SELECT;
  }
  if (tool === shapeTool) {
    switch (shapeTool.type) {
      case ShapeTool.SHAPE_TYPE.RECT:
        return WhiteboardTool.RECT;
      case ShapeTool.SHAPE_TYPE.RECT_FILL:
        return WhiteboardTool.RECT_FILL;
      case ShapeTool.SHAPE_TYPE.ELLIPSE:
        return WhiteboardTool.ELLIPSE;
      case ShapeTool.SHAPE_TYPE.ELLIPSE_FILL:
        return WhiteboardTool.ELLIPSE_FILL;
      case ShapeTool.SHAPE_TYPE.LINE:
        return WhiteboardTool.LINE;
      case ShapeTool.SHAPE_TYPE.LINE_ARROW:
        return WhiteboardTool.LINE_ARROW;
      default:
        return WhiteboardTool.RECT;
    }
  }
  if (tool === textTool) {
    return WhiteboardTool.TEXT;
  }
  return WhiteboardTool.PEN;
};
